/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/qaTemplateWriteTarget.ts
 * FILE_ID: JOBHUB-QA-TEMPLATE-WRITE-TARGET-001
 * PURPOSE: Decide which QA receives a template insert.
 */
import type { QaApi } from '../../../qa/qaApi'
import type { QaFromTemplatesPayload } from '../../../qa/qaTemplateTypes'

export type QaTemplateWriteChoice = 'create' | 'add' | 'replace'

export function storedWriteChoice(
  pending: QaTemplateWriteChoice | null | undefined,
  alreadyChosen: boolean,
): QaTemplateWriteChoice | null {
  if (!pending || alreadyChosen) return null
  return pending
}

export async function resolveTemplateInsertTarget(args: {
  api: Pick<QaApi, 'generateFromTemplates' | 'clearInspectionStructure'>
  jobId: number
  workspace: {
    activeInspectionId: string | null
    selectInspection?: (inspectionId: string | null) => void
    openCreatedInspection?: (inspectionId: string) => void
  }
  choice: QaTemplateWriteChoice
  name: string
  targetAreaIds: string[]
}): Promise<{ inspectionId: string; targetAreaIds: string[] }> {
  if (args.choice === 'create') {
    const payload: QaFromTemplatesPayload = {
      job_id: args.jobId,
      inspection_name: args.name,
      areas: [],
    }
    const created = await args.api.generateFromTemplates(payload)
    if (args.workspace.openCreatedInspection) args.workspace.openCreatedInspection(created.id)
    else args.workspace.selectInspection?.(created.id)
    return { inspectionId: created.id, targetAreaIds: [] }
  }
  const inspectionId = args.workspace.activeInspectionId || ''
  if (args.choice === 'replace') {
    await args.api.clearInspectionStructure(inspectionId)
    return { inspectionId, targetAreaIds: [] }
  }
  return { inspectionId, targetAreaIds: args.targetAreaIds }
}
